/**
 * The Naked Tiger cart drawer extras
 * - Countdown timer ("Your offer is reserved for")
 * - "Add" buttons in "Complete the look"
 * - Bin icon that removes an item
 */
(function () {
  'use strict';

  var TIMER_KEY = 'ntCartTimerEnd';
  var timerEndFallback = null;

  function url(name, fallback) {
    var r = window.routes || {};
    return (r[name] || fallback) + '.js';
  }

  function postJSON(endpoint, data) {
    return fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(data)
    }).then(function (res) {
      return res.json().then(function (json) {
        if (!res.ok) {
          throw new Error(json.description || json.message || 'Something went wrong. Please try again.');
        }
        return json;
      });
    });
  }

  function getDrawer() {
    return document.querySelector('cart-drawer');
  }

  function showError(message) {
    var el = document.getElementById('CartDrawer-CartErrors');
    if (el) el.textContent = message;
  }

  /* ---------- Timer ---------- */

  function readTimerEnd() {
    try {
      var stored = parseInt(window.sessionStorage.getItem(TIMER_KEY), 10);
      if (stored) return stored;
    } catch (e) {}
    return timerEndFallback;
  }

  function saveTimerEnd(value) {
    timerEndFallback = value;
    try {
      window.sessionStorage.setItem(TIMER_KEY, String(value));
    } catch (e) {}
  }

  function updateTimer() {
    var el = document.querySelector('#CartDrawer [data-nt-timer]');
    if (!el) return;

    var minutes = parseFloat(el.getAttribute('data-minutes')) || 0;
    if (minutes <= 0) {
      el.hidden = true;
      return;
    }

    var end = readTimerEnd();
    var drawer = getDrawer();
    var drawerOpen = drawer && drawer.classList.contains('active');

    // The countdown starts the first time the shopper sees the drawer
    if (!end && drawerOpen) {
      end = Date.now() + minutes * 60000;
      saveTimerEnd(end);
    }

    var secondsLeft = end ? Math.round((end - Date.now()) / 1000) : Math.round(minutes * 60);
    if (secondsLeft <= 0) {
      el.hidden = true;
      return;
    }

    var m = Math.floor(secondsLeft / 60);
    var s = secondsLeft % 60;
    var value = el.querySelector('[data-nt-timer-value]');
    if (value) value.textContent = m + ':' + (s < 10 ? '0' : '') + s;
    el.hidden = false;
  }

  /* ---------- "Complete the look" Add buttons ---------- */

  function addToCart(button, variantId) {
    var label = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding…';
    showError('');

    postJSON(url('cart_add_url', '/cart/add'), {
      items: [{ id: variantId, quantity: 1 }],
      sections: ['cart-drawer', 'cart-icon-bubble'],
      sections_url: window.location.pathname
    })
      .then(function (state) {
        var drawer = getDrawer();
        if (drawer && typeof drawer.renderContents === 'function') {
          drawer.renderContents(state);
        }
      })
      .catch(function (error) {
        button.disabled = false;
        button.textContent = label;
        showError(error.message);
      });
  }

  /* ---------- Bin icon: removes the item ---------- */

  function removeLine(button) {
    var line = parseInt(button.getAttribute('data-nt-line'), 10);
    if (!line) return;

    var row = button.closest('.cart-item');
    button.disabled = true;
    if (row) row.style.opacity = '0.5';
    showError('');

    postJSON(url('cart_change_url', '/cart/change'), {
      line: line,
      quantity: 0,
      sections: ['cart-drawer', 'cart-icon-bubble'],
      sections_url: window.location.pathname
    })
      .then(function (state) {
        var drawer = getDrawer();
        if (drawer && typeof drawer.renderContents === 'function') {
          drawer.renderContents(state);
          drawer.classList.toggle('is-empty', state.item_count === 0);
        }
      })
      .catch(function (error) {
        button.disabled = false;
        if (row) row.style.opacity = '';
        showError(error.message);
      });
  }

  document.addEventListener('click', function (event) {
    var removeButton = event.target.closest('#CartDrawer [data-nt-line]');
    if (removeButton) {
      event.preventDefault();
      removeLine(removeButton);
      return;
    }

    var addButton = event.target.closest('#CartDrawer [data-nt-add]');
    if (!addButton) return;

    event.preventDefault();
    var card = addButton.closest('.nt-card');
    var select = card ? card.querySelector('[data-nt-variant-select]') : null;
    var variantId = parseInt(select ? select.value : addButton.getAttribute('data-variant-id'), 10);
    if (variantId) addToCart(addButton, variantId);
  });

  /* ---------- Wiring ---------- */

  document.addEventListener('cart:refresh', updateTimer);

  document.addEventListener('DOMContentLoaded', function () {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, updateTimer);
    }
    updateTimer();
    setInterval(updateTimer, 1000);
  });
})();